/* eslint-disable import/no-anonymous-default-export */
import _ from 'lodash'
export default ({ month, language = 'TH'}) => {
  switch (_.toString(month)) {
    case '1':
    case '01': return language === 'TH' ? 'ม.ค.' : 'Jan.'
    case '2':
    case '02': return language === 'TH' ? 'ก.พ.' : 'Feb.'
    case '3':
    case '03': return language === 'TH' ? 'มี.ค.' : 'Mar.'
    case '4':
    case '04': return language === 'TH' ? 'เม.ย.' : 'Apr.'
    case '5':
    case '05': return language === 'TH' ? 'พ.ค.' : 'May'
    case '6':
    case '06': return language === 'TH' ? 'มิ.ย.' : 'Jun.'
    case '7':
    case '07': return language === 'TH' ? 'ก.ค.' : 'Jul.'
    case '8':
    case '08': return language === 'TH' ? 'ส.ค.' : 'Aug.'
    case '9':
    case '09': return language === 'TH' ? 'ก.ย.' : 'Sep.'
    case '10': return language === 'TH' ? 'ต.ค.' : 'Oct.'
    case '11': return language === 'TH' ? 'พ.ย.' : 'Nov.'
    case '12': return language === 'TH' ? 'ธ.ค.' : 'Dec.'
    default: return ''
  }
}